import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../lib/api";
import { ui } from "../lib/ui";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Please log in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto px-4 sm:px-8 py-16 text-center">
        <p className="text-[#8B1A1A]">This reset link is missing its token.</p>
        <Link to="/forgot-password" className={ui.btnSecondary + " mt-5"}>Request a new link</Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto px-4 sm:px-8 py-16">
      <h1 className="font-serif text-3xl font-bold text-[#8B1A1A] mb-2">Set a new password</h1>
      <form onSubmit={submit} className={ui.card + " p-6 space-y-5 mt-8"} data-testid="reset-form">
        <div>
          <label className={ui.label}>New password <span className="font-normal text-[#5A4441]">(min 6 characters)</span></label>
          <input type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={ui.input} data-testid="reset-password-input" />
        </div>
        <button type="submit" disabled={loading} className={ui.btnPrimary + " w-full"} data-testid="reset-submit-btn">
          {loading ? "Saving…" : "Reset password"}
        </button>
      </form>
    </div>
  );
}
